import { Reveal } from "./Reveal";
import { Mail, Image as ImageIcon, Lightbulb } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const pains = [
  {
    icon: Mail,
    title: "Responder e-mail mais rápido",
    desc: "Cola o texto, pede pra reescrever, copia de volta. Ganhou 5 minutos — e parou aí.",
  },
  {
    icon: ImageIcon,
    title: "Escrever um post de Instagram",
    desc: "Pede a legenda, ajusta o tom, posta. Amanhã é tudo de novo, do zero.",
  },
  {
    icon: Lightbulb,
    title: "Pedir uma ideia de campanha",
    desc: "Ela responde, você lê, fecha a aba. A rotina continua exatamente igual.",
  },
];

export function ProblemSection() {
  return (
    <section className="relative py-12 md:py-16">
      <div className="container-narrow">
        <SectionHeading
          eyebrow="Onde você está hoje"
          title="Você já testou IA. Mas continua fazendo na mão o que ela poderia fazer por você."
          subtitle="No máximo, você usa pra acelerar uma tarefa pontual. Útil — mas é IA fazendo tarefa. Não é IA trabalhando por você."
        />

        <div className="mx-auto mt-10 grid max-w-5xl gap-4 md:grid-cols-3">
          {pains.map((p, i) => (
            <Reveal y={16} duration={0.5} delay={i * 0.08}
              key={p.title}
              className="grid grid-cols-[auto_minmax(0,1fr)] items-start gap-4 rounded-2xl border border-border/60 bg-card/50 p-5 transition-colors hover:border-gold/40 md:block md:p-6"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-gold shadow-elegant md:mb-4">
                <p.icon className="h-4 w-4 text-primary-foreground" />
              </span>
              <div className="min-w-0">
                <h3 className="mb-1.5 text-lg leading-snug text-ivory">
                  {p.title}
                </h3>
                <p className="text-pretty text-sm leading-relaxed text-slate-muted">
                  {p.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal y={20} duration={0.6}
          className="mx-auto mt-12 max-w-3xl"
        >
          <p className="mb-4 text-[11px] font-bold uppercase tracking-[0.32em] text-gold">
            Por que isso acontece
          </p>
          <h3 className="text-balance text-2xl leading-tight text-ivory md:text-4xl">
            Não é porque você não sabe usar IA.{" "}
            <span className="italic text-gold-soft">Você já usou.</span>
          </h3>

          <p className="mt-6 text-pretty text-base leading-relaxed text-slate-muted md:text-lg">
            O que faltou foi alguém sentar com você, mapear a sua operação e
            definir{" "}
            <span className="text-ivory/90">
              onde a IA entra e como ela se comporta especificamente no seu
              negócio
            </span>
            . Sem isso, você virou operador da IA — e não dono de uma IA que
            opera.
          </p>

          <div className="mt-8 rounded-2xl border border-gold/30 bg-card/50 p-6 md:p-8">
            <p
              className="text-pretty text-lg leading-relaxed text-ivory md:text-xl"
              style={{ fontFamily: "var(--font-display)" }}
            >
              A IA não falhou. Faltou{" "}
              <span className="italic text-gold-soft">
                mapeamento e configuração com o contexto real da sua empresa.
              </span>{" "}
              É isso que o SPRINT CODE resolve.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
